import { render, staticRenderFns } from "./AiproxyClientAccessDetail.vue?vue&type=template&id=b2ebd0f0&scoped=true"
import script from "./AiproxyClientAccessDetail.vue?vue&type=script&lang=js"
export * from "./AiproxyClientAccessDetail.vue?vue&type=script&lang=js"
import style0 from "./AiproxyClientAccessDetail.vue?vue&type=style&index=0&id=b2ebd0f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ebd0f0",
  null
  
)

export default component.exports